import { useCoy } from "../../contexts/AuthContext";

const Footer = () => {
    const coy = useCoy();
    return <footer className="sticky-footer py-2">
        <div className="container my-auto">
            <div className="text-center my-auto copyright"><strong>Copyright © {coy.name} {(new Date()).getFullYear()}</strong></div>
        </div>
    </footer>
}
export default Footer;